<template>
  <div>
    <SearchNavHeader :currentPage="'searchTags'"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6 mx-auto">
          <div class="row mt-4">
            <div class="col-12 text-center">
              <v-autocomplete
                  v-if="showSearchBox"
                  v-model="hashtagId"
                  append-icon="far fa-search"
                  class="rounded-lg search-combobox"
                  dense
                  :items="hashtags"
                  item-value="HashTagID"
                  item-text="Content"
                  flat
                  hide-details
                  placeholder="جستجو در هشتگ ها..."
                  solo
                  @click:append="searchBtn"
                  @keydown="search($event)"></v-autocomplete>

              <span v-else class=" rounded-xl bg-white py-2 px-3 d-inline-block position-relative">
             {{ searchKeyWordName }}
             <v-btn class=" pl-1 close-search-key-btn" icon small @click="removeSearchKeyword"><i
                 class="fa-regular fa-circle-xmark pointer font16px "></i></v-btn>
          </span>
            </div>
          </div>
          <div class="min-height-300px">
            <div v-if="!hasResult" class="col-12 text-center mt-15">
              نتیجه ای یافت نشد
            </div>
            <masonry v-else
                     :cols="{default: 4, 1000: 3, 700: 2}">
              <router-link v-for="(item,i) in posts" :key="i"
                           :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                           class="p-1 mx-auto d-block">
                <v-img v-if="item.FileCoverUrl !== null" :src="$replaceHttps(item.FileCoverUrl)"
                       class=" rounded-11px">
                  <div class="p-2">
                    <div v-if="item.TypeStrucGallery ===2"><i
                        class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                    <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                    </div>
                  </div>
                </v-img>
                <v-img v-else :src="$replaceHttps(item.FileUrl)" class=" rounded-11px">
                  <div class="p-2">
                    <div v-if="item.TypeStrucGallery ===2"><i
                        class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                    <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                    </div>
                  </div>
                </v-img>
              </router-link>
            </masonry>
          </div>
        </div>
      </div>

    </div>

    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>


 </div>
</template>

<script>
import SearchNavHeader from "@/views/Search/SearchNavHeader";

export default {
  name: "SearchTags",
  metaInfo: {
    title: 'ایوان خانه- جستجوی هشتگ',
  },
  components: {SearchNavHeader},
  data: () => ({
    showSearchBox: true,
    showLoaderDialog: false,
    hasResult: true,
    hashtagId: null,
    searchKeyWordName: null,
    posts: [],
    hashtags:[]

  }),
mounted() {
  this.getHashtags();
  this.getPosts();
},
  methods: {
    getHashtags() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/GetHashTags", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.hashtags =JSON.parse(result)
            this.categoriesLoading = false
          })
          .catch(error => console.log('error', error));
    },
    search(e) {
      if (e.keyCode === 13) {
        let hashtags = this.hashtags
        this.searchKeyWordName = hashtags.find(x=>x.HashTagID === this.hashtagId).Content
       this.searchBtn()
      }
    },
    searchBtn(){
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("HashTagID", this.hashtagId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/GetSocialById", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.hasResult = json.length !== 0;
            this.posts= json
           this.showLoaderDialog= false
          })
          .catch(error => console.log('error', error));
      this.showSearchBox = false
    },
    getPosts() {
     this.showLoaderDialog=true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", "1");
      urlencoded.append("pageSize", "100");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.posts = (JSON.parse(result).list).filter(x => x.IsActive === true)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    removeSearchKeyword() {
      this.showSearchBox = true
      this.hasResult=true
      this.hashtagId = null
      this.posts=[]
    }
  }

}
</script>

<style scoped>

</style>
